(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2986],{

/***/ 36453:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/my-services",
      function () {
        return __webpack_require__(98635);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_MyGenericFiller; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Shared/OrderHistory/v1/OrderProgressiveLoading.jsx
var OrderProgressiveLoading = __webpack_require__(8684);
// EXTERNAL MODULE: ./src/components/core/PageLoader/PageLoader.jsx
var PageLoader = __webpack_require__(44273);
// EXTERNAL MODULE: ./src/components/AccountsLayout/AccountsLayout/index.jsx
var AccountsLayout = __webpack_require__(73973);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(72433);
;// CONCATENATED MODULE: ./src/i18n/useGeneric.js

const useGeneric = (param)=>{
    let { componentProps: { headLine  } = {}  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        myAccount: t("kf.account.label.myAccount"),
        myServices: t("kf.account.label.myServices"),
        favoriteTitle: t("kf.favorite.label.favoriteTitle"),
        orders: t("kf.account.label.orders"),
        myProducts: headLine !== null && headLine !== void 0 ? headLine : t("kf.myProducts.label.myProducts"),
        hi: t("kf.account.label.hi"),
        accountSettings: t("kf.account.label.accountSettings")
    };
    return i18n;
};
/* harmony default export */ var i18n_useGeneric = (useGeneric);

;// CONCATENATED MODULE: ./src/components/MyGenericFiller.jsx






const MyGenericFiller = (param)=>{
    let { data: componentProps , title  } = param;
    const staticTexts = i18n_useGeneric({
        componentProps
    });
    (0,react.useEffect)(()=>{
        window.scrollTo({
            top: 1,
            behavior: "smooth"
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccountsLayout/* default */.Z, {
        title: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts[title],
        staticTexts: staticTexts,
        i18n: staticTexts,
        accountLayoutLoader: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader/* default */.Z, {
                loading: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderProgressiveLoading/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var components_MyGenericFiller = (MyGenericFiller);


/***/ }),

/***/ 73812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v2_Sort; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./public/icons/arrow-up.svg
var arrow_up = __webpack_require__(97274);
;// CONCATENATED MODULE: ./src/components/ProductList/v2/Sort/sortAnalytics.js
const getAnalyticsData = function(item) {
    let needJson = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, { selectedtab , page  } = arguments.length > 2 ? arguments[2] : void 0;
    let analyticsData = {
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(item.name),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    if (page === "search" && selectedtab === "technical") {
        analyticsData = {
            ...analyticsData,
            eventAction: "search results:technical:main content area:sort by",
            eventName: "search results:technical:main content area:sort by",
            internalLinkPosition: "search results",
            internalLinkType: "search results:sort by",
            internalLinkZoneName: "search results:technical:main content area"
        };
    }
    switch(page){
        case "search":
            analyticsData = {
                ...analyticsData,
                eventAction: "search results:".concat(selectedtab, ":main content area:sort by"),
                eventName: "search results:".concat(selectedtab, ":main content area:sort by"),
                internalLinkPosition: "search results",
                internalLinkType: "search results:sort by",
                internalLinkZoneName: "search results:".concat(selectedtab, ":main content area")
            };
            break;
        case "favorites":
            analyticsData = {
                ...analyticsData,
                eventAction: "my account:favorites:".concat(selectedtab, ":sort by"),
                eventName: "my account:favorites:".concat(selectedtab, ":sort by"),
                internalLinkPosition: "favorites",
                internalLinkType: "my account:sort by",
                internalLinkZoneName: "my account:favorites:".concat(selectedtab)
            };
            break;
        case "article":
            analyticsData = {
                ...analyticsData,
                eventAction: "support:help and faq:article list​:sort by",
                eventName: "support:help and faq:article list​:sort by",
                internalLinkPosition: "knowledge articles",
                internalLinkType: "support:help and faq:sort by",
                internalLinkZoneName: "support:help and faq:article list​​"
            };
            break;
        case "active-services":
            analyticsData = {
                ...analyticsData,
                eventAction: "my account:services:active services​:sort by",
                eventName: "my account:services:active services​:sort by",
                internalLinkPosition: "my services",
                internalLinkType: "my account:sort by",
                internalLinkZoneName: "my account:services:active services"
            };
            break;
        case "past-services":
            analyticsData = {
                ...analyticsData,
                eventAction: "my account:services:past services​:sort by",
                eventName: "my account:services:past services​:sort by",
                internalLinkPosition: "my services",
                internalLinkType: "my account:sort by",
                internalLinkZoneName: "my account:services:past services"
            };
            break;
        case "literature":
            analyticsData = {
                ...analyticsData,
                eventAction: "literature:sort by",
                eventName: "literature:sort by",
                internalLinkPosition: "literature",
                internalLinkType: "literature:sort by",
                internalLinkZoneName: "literature:main content area"
            };
            break;
        case "press-release":
            analyticsData = {
                ...analyticsData,
                eventAction: "press room:press releases:sort by",
                eventName: "press room:press releases:sort by",
                internalLinkPosition: "press room",
                internalLinkType: "press room:sort by",
                internalLinkZoneName: "press room:press releases:main content area"
            };
            break;
        case "press-kits":
            analyticsData = {
                ...analyticsData,
                eventAction: "press room:press kits:sort by",
                eventName: "press room:press kits:sort by",
                internalLinkPosition: "press room",
                internalLinkType: "press room:sort by",
                internalLinkZoneName: "press room:press kits:main content area"
            };
            break;
        case "my products":
            analyticsData = {
                ...analyticsData,
                eventAction: "my account:products:sort by filter",
                eventName: "my account:products:sort by filter",
                internalLinkPosition: "my account",
                internalLinkType: "my account:sort by",
                internalLinkZoneName: "my account:products"
            };
            break;
        default:
            analyticsData = {
                ...analyticsData,
                eventAction: "plp sort by filter",
                eventName: "plp sort by filter",
                internalLinkPosition: "plp",
                internalLinkType: "plp:sort by",
                internalLinkZoneName: "plp:sort by filter"
            };
    }
    if (needJson) return analyticsData;
    return JSON.stringify(analyticsData);
};

// EXTERNAL MODULE: ./src/hooks/useIsSsr.js
var useIsSsr = __webpack_require__(7154);
;// CONCATENATED MODULE: ./src/hooks/useOnClickOutside.js


/**
 *
 * @param {*} ref
 * @param {*} handler
 */ const useOnClickOutside = (ref, handler)=>{
    const isSsr = (0,useIsSsr/* default */.Z)();
    (0,react.useEffect)(()=>{
        const listener = (event)=>{
            // Do nothing if clicking ref's element or descendent elements
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        if (!isSsr) {
            document.addEventListener("mousedown", listener);
            document.addEventListener("touchstart", listener);
        }
        return ()=>{
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [
        ref,
        handler,
        isSsr
    ]);
};
/* harmony default export */ var hooks_useOnClickOutside = (useOnClickOutside);

;// CONCATENATED MODULE: ./src/components/ProductList/v2/Sort/index.jsx






function Sort(param) {
    let { texts ={} , data =[] , selectedSort , onChange , page , selectedtab , tabIndex =0 , isMyFavoriteTab =false  } = param;
    const id = (0,react.useId)();
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const [activeIndex, setActiveIndex] = (0,react.useState)(0);
    const wrapper = (0,react.useRef)(null);
    const trigger = (0,react.useRef)(null);
    const options = (0,react.useRef)([]);
    const label = texts.sort || texts.sortByAria || "Sort by";
    hooks_useOnClickOutside(wrapper, ()=>setIsOpen(false));
    (0,react.useEffect)(()=>{
        var ref;
        if (isOpen) (ref = options.current[activeIndex]) === null || ref === void 0 ? void 0 : ref.focus();
    }, [
        isOpen,
        activeIndex
    ]);
    const open = ()=>{
        if (!data.length) return;
        setActiveIndex(Math.max(0, data.findIndex((item)=>{
            return item.name === (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.name);
        })));
        setIsOpen(true);
    };
    const close = ()=>{
        var ref;
        setIsOpen(false);
        (ref = trigger.current) === null || ref === void 0 ? void 0 : ref.focus();
    };
    const select = (item)=>{
        onChange(item);
        close();
    };
    const onOptionKeyDown = (event, index)=>{
        switch(event.key){
            case "ArrowDown":
                event.preventDefault();
                setActiveIndex((index + 1) % data.length);
                break;
            case "ArrowUp":
                event.preventDefault();
                setActiveIndex((index - 1 + data.length) % data.length);
                break;
            case "Home":
            case "End":
                event.preventDefault();
                setActiveIndex(event.key === "Home" ? 0 : data.length - 1);
                break;
            case "Enter":
            case " ":
                event.preventDefault();
                select(data[index]);
                break;
            case "Escape":
                event.preventDefault();
                event.stopPropagation();
                close();
                break;
            case "Tab":
                // Return to the trigger before the browser performs normal Tab navigation.
                close();
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "sort".concat(isOpen ? " sort--open" : ""),
        ref: wrapper,
        onBlur: (event)=>{
            if (!event.currentTarget.contains(event.relatedTarget)) setIsOpen(false);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                tabIndex: tabIndex,
                className: "sort__toggle",
                ref: trigger,
                id: "".concat(id, "-label"),
                "aria-haspopup": "listbox",
                "aria-expanded": isOpen,
                "aria-controls": "".concat(id, "-options"),
                onClick: ()=>isOpen ? close() : open(),
                onKeyDown: (event)=>{
                    if ([
                        "ArrowDown",
                        "ArrowUp"
                    ].includes(event.key)) {
                        event.preventDefault();
                        open();
                    } else if (event.key === "Escape" && isOpen) {
                        event.preventDefault();
                        close();
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sort-by-text",
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sort-options",
                        children: " ".concat(isMyFavoriteTab ? "" : ":", " ").concat((selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.name) || "Featured")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: arrow_up/* default */.Z === null || arrow_up/* default */.Z === void 0 ? void 0 : arrow_up/* default.src */.Z.src,
                        alt: "",
                        className: "sort__toggle-icon"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                id: "".concat(id, "-options"),
                className: "sort__drop-down",
                role: "listbox",
                "aria-labelledby": "".concat(id, "-label"),
                hidden: !isOpen,
                style: !isOpen ? {
                    display: "none"
                } : undefined,
                children: data.map((item, index)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                        id: "".concat(id, "-option-").concat(index),
                        role: "option",
                        ref: (element)=>{
                            options.current[index] = element;
                        },
                        tabIndex: isOpen && activeIndex === index ? 0 : -1,
                        "aria-selected": item.name === (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.name),
                        className: "sort__item gbh-data-layer".concat(item.name === (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.name) ? " active" : ""),
                        "data-gbh-data-layer": getAnalyticsData(item, null, {
                            selectedtab,
                            page
                        }),
                        onFocus: ()=>setActiveIndex(index),
                        onClick: ()=>select(item),
                        onKeyDown: (event)=>onOptionKeyDown(event, index),
                        children: item.name
                    }, index);
                })
            })
        ]
    });
}
/* harmony default export */ var v2_Sort = ((0,lib/* withOrientationChange */.Qe)(Sort));


/***/ }),

/***/ 85614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2693);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64925);
/* harmony import */ var _hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97349);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27514);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87292);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7154);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19514);









const usePageAuth = ()=>{
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    const { access_token: accessToken  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .selectAuthState */ ._9);
    const { cart: activeCart , isCartLoading  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .selectCartState */ .xw);
    const prevToken = (0,_hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        accessToken
    });
    // just for the dev testing purpose, if works fine then can only be proceed otherwise
    // one more pr will be raised to revert the change
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        let timeoutId;
        if (!isSsr) {
            timeoutId = setTimeout(()=>{
                if (!accessToken || !(0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .isGuestTokenValid */ .DVc)()) {
                    dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .getOktaToken */ .cs)({
                        type: "guest"
                    }));
                }
            }, 5000);
        }
        ;
        ()=>{
            clearTimeout(timeoutId);
        };
    }, [
        accessToken,
        isSsr
    ]);
    const callInitAuth = async ()=>{
        var ref;
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .i)();
        const disableCommerce = (config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.disableCommerce) || false;
        if (disableCommerce) return;
        const hasNoActiveCart = ()=>{
            return (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .isGuestTokenValid */ .DVc)() && accessToken && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.id) && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.cartExists);
        };
        if (hasNoActiveCart() || hasNoActiveCart() && (prevToken === null || prevToken === void 0 ? void 0 : prevToken.accessToken) !== accessToken) {
            if (!isCartLoading) {
                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(true));
                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .getCart */ .dv)()).unwrap().then((res)=>{
                    if ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .isGuestTokenValid */ .DVc)() && accessToken && (res === null || res === void 0 ? void 0 : res.cartExists) && (res === null || res === void 0 ? void 0 : res.cartExists) === "false" && (res === null || res === void 0 ? void 0 : res.error) === "No active cart exists.") {
                        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getCurrency */ .zC$)().then((currency)=>{
                            const cartPayload = {
                                currency: currency,
                                taxMode: "ExternalAmount"
                            };
                            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .createCart */ .Bk)(cartPayload)).unwrap().then(()=>{
                                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(false));
                            });
                        });
                    } else {
                        dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(false));
                    }
                });
            }
        }
        (0,_utils_cart__WEBPACK_IMPORTED_MODULE_6__/* .setCartLandingPagePath */ .NS)();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (isSsr) return;
        callInitAuth();
    }, [
        accessToken,
        isSsr
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (usePageAuth);


/***/ }),

/***/ 97349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const usePrevious = (value)=>{
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
};
/* harmony default export */ __webpack_exports__["Z"] = (usePrevious);


/***/ }),

/***/ 98635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ my_services; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./src/components/cart/cartHelper.js + 1 modules
var cartHelper = __webpack_require__(42423);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(72433);
;// CONCATENATED MODULE: ./src/i18n/useMyServices.js

const useMyServicei18n = (param)=>{
    let { componentProps  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        newToOld: t("kf.myProducts.sort.newToOld"),
        oldToNew: t("kf.myProducts.sort.oldToNew"),
        AToZ: t("kf.services.sort.AToZ"),
        ZToA: t("kf.services.sort.ZToA"),
        myServices: t("kf.services.label.myServices"),
        sort: t("kf.services.label.sortBy"),
        sortbyExpanded: t("kf.plp.label.sortbyExpanded"),
        sortbyClosed: t("kf.plp.label.sortbyClosed"),
        selected: t("kf.plp.arialabel.selected"),
        altSort: t("kf.plp.label.img.altSort"),
        activeServices: t("kf.services.label.activeServices"),
        noServices: t("kf.services.label.noServices"),
        continueShopping: t("kf.services.label.continueShopping"),
        pastServices: t("kf.services.label.pastServices"),
        completedServices: t("kf.services.label.completedServices"),
        sortByAria: (count)=>t("kf.plp.label.sortByAria", {
                sortByCount: count
            }),
        hi: t("kf.account.label.hi"),
        signOut: t("kf.account.label.signOut"),
        myAccount: t("kf.account.label.myAccount"),
        favorites: t("kf.account.label.favorites"),
        accountSettings: t("kf.account.label.accountSettings"),
        orders: t("kf.account.label.orders"),
        myProducts: t("kf.account.label.myProducts"),
        myServices: t("kf.account.label.myServices"),
        shopServices: t("kf.services.label.shopServices")
    };
    return i18n;
};
/* harmony default export */ var useMyServices = (useMyServicei18n);

// EXTERNAL MODULE: ./src/store/features/authSlice.js
var authSlice = __webpack_require__(2693);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/AccountsLayout/AccountsLayout/index.jsx
var AccountsLayout = __webpack_require__(73973);
// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./src/components/ProductList/v2/Sort/index.jsx + 2 modules
var Sort = __webpack_require__(73812);
// EXTERNAL MODULE: ./src/components/MyServices/v1/MyServices.view/index.module.scss
var index_module = __webpack_require__(95336);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./src/hooks/useWindowResize.js
var useWindowResize = __webpack_require__(18216);
;// CONCATENATED MODULE: ./src/components/MyServices/v1/MyServices.view/index.jsx











const MyServices = (param)=>{
    let { i18n ={} , servicelist ={} , isAuth =Boolean , user ={} , data =[] , logout =()=>{} , redirect =()=>{} , onSort =()=>{} , sorts =[] , continueShoppingData ={} , selectedSort ={} , isLoading =false  } = param;
    const [width] = (0,useWindowResize/* default */.Z)();
    const [scene7AccountName, setScene7AccountName] = (0,react.useState)("");
    const [swatchUrl, setSwatchUrl] = (0,react.useState)("");
    const [siteName, setSiteName] = (0,react.useState)("");
    const [continueShoppingURL, setContinueShoppingURL] = (0,react.useState)("");
    const activeSort = (query)=>onSort(query, "active");
    const pastSort = (query)=>onSort(query, "past");
    const continueShoppingLabel = continueShoppingData.label ? continueShoppingData.label : i18n.shopServices;
    const serviceImageWidth = 138;
    const serviceImageHeight = 186;
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            const { general: { scene7AccountName ="" , swatchUrl ="" , siteName =""  }  } = config;
            setScene7AccountName(scene7AccountName);
            setSwatchUrl(swatchUrl);
            setSiteName(siteName);
            getContinueShoppingURL();
        });
    }, []);
    const getContinueShoppingURL = async ()=>{
        const { link  } = continueShoppingData;
        const urlLink = await (0,helper/* getShortenedUrl */.Ppy)(link);
        setContinueShoppingURL("".concat(urlLink));
    };
    const { myServices , activeServices , noServices , completedServices  } = i18n;
    const presetConfigsData = (continueShoppingData === null || continueShoppingData === void 0 ? void 0 : continueShoppingData.presetConfigs) ? JSON.parse(continueShoppingData === null || continueShoppingData === void 0 ? void 0 : continueShoppingData.presetConfigs) : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((index_module_default()).myserviceWrapper, " myServiceView_wrapper"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccountsLayout/* default */.Z, {
            title: myServices,
            activeTab: 4,
            isAuth: isAuth,
            user: user,
            i18n: i18n,
            logout: logout,
            data: data,
            redirect: redirect,
            children: [
                servicelist.active.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "my-service__active-service",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "my-service__header",
                            children: [
                                servicelist.active.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "my-service__service-title",
                                    children: activeServices
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "my-service__title"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Sort/* default */.Z, {
                                    page: "active-services",
                                    data: sorts,
                                    texts: i18n,
                                    onChange: activeSort,
                                    selectedSort: selectedSort,
                                    isMyserviceTab: true
                                })
                            ]
                        }),
                        servicelist.active.map((item, i)=>{
                            var ref;
                            const presetImageUrl = (0,helper/* getPresetUrl */.v$f)(width, swatchUrl, item === null || item === void 0 ? void 0 : item.image, presetConfigsData, scene7AccountName);
                            const imageUrl = (siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase()) === (item === null || item === void 0 ? void 0 : (ref = item.brandName) === null || ref === void 0 ? void 0 : ref.toLowerCase()) ? presetImageUrl : item === null || item === void 0 ? void 0 : item.image;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "my-service__list-box",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        onError: (e)=>{
                                            return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                        },
                                        src: imageUrl || (image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src),
                                        width: serviceImageWidth,
                                        height: serviceImageHeight,
                                        alt: "Service Image"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "my-service__product-content",
                                        children: [
                                            item.expirationDate && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "expires",
                                                children: "EXPIRES ".concat(item.expirationDate)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "brand",
                                                children: item.brandName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "name",
                                                children: item.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "purchased",
                                                children: "Purchased : ".concat(item.lastPurchasedOn)
                                            })
                                        ]
                                    })
                                ]
                            }, i);
                        })
                    ]
                }) : !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "active-service-sec",
                    children: [
                        servicelist.past.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: "".concat(activeServices)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "".concat(noServices)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: "gbh-data-layer",
                                    role: "link",
                                    "data-gbh-data-layer": '{"eventAction":"my account:services:active services:continue shopping","eventName":"my account:services:active services:continue shopping","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"continue shopping","internalLinkPosition":"my services","internalLinkType":"my account:navigation","internalLinkZoneName":"my account:services:active services","internalLinkURL":"n/a","clickInternalLinks":"true"}',
                                    type: "black",
                                    to: continueShoppingURL,
                                    target: "_self",
                                    label: continueShoppingLabel,
                                    useDefaultClass: true,
                                    tag: "anchor"
                                })
                            ]
                        })
                    ]
                }),
                servicelist.past.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "my-service__completed-service",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "my-service__header",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "my-service__title",
                                    children: completedServices
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Sort/* default */.Z, {
                                    page: "past-services",
                                    data: sorts,
                                    texts: i18n,
                                    onChange: pastSort,
                                    selectedSort: selectedSort,
                                    isMyserviceTab: true
                                })
                            ]
                        }),
                        servicelist.past.map((item, i)=>{
                            var ref;
                            const presetImageUrl = (0,helper/* getPresetUrl */.v$f)(width, swatchUrl, item === null || item === void 0 ? void 0 : item.image, presetConfigsData, scene7AccountName);
                            const imageUrl = (siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase()) === (item === null || item === void 0 ? void 0 : (ref = item.brandName) === null || ref === void 0 ? void 0 : ref.toLowerCase()) ? presetImageUrl : item === null || item === void 0 ? void 0 : item.image;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "my-service__list-box my-service__past-list-box",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        onError: (e)=>{
                                            return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                        },
                                        src: imageUrl || (image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src),
                                        width: serviceImageWidth,
                                        height: serviceImageHeight,
                                        alt: "Service Image"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "my-service__product-content",
                                        children: [
                                            item.expirationDate && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "expires",
                                                children: "EXPIRED ".concat(item.expirationDate)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "brand",
                                                children: item.brandName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "name",
                                                children: item.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "purchased",
                                                children: "Purchased : ".concat(item.lastPurchasedOn)
                                            })
                                        ]
                                    })
                                ]
                            }, i);
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var MyServices_view = (MyServices);

// EXTERNAL MODULE: ./src/utils/orders.js
var orders = __webpack_require__(53499);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 2 modules
var redux_toolkit_esm = __webpack_require__(77236);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./constants/index.js + 2 modules
var constants = __webpack_require__(47956);
;// CONCATENATED MODULE: ./src/store/features/accountSlice.js



const getServices = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("getServices", async ()=>{
    let serviceList = [];
    try {
        const res = await api/* apim.get */.TH.get("".concat(constants.MY_SERVICES_ENDPOINT));
        if (res && res.data && res.data.results) {
            serviceList = res.data.results;
        }
    } catch (err) {
        console.error("Failed to fetch past orders", err);
    }
    return serviceList;
});

// EXTERNAL MODULE: ./src/components/MyGenericFiller.jsx + 1 modules
var MyGenericFiller = __webpack_require__(56586);
;// CONCATENATED MODULE: ./src/components/MyServices/v1/MyServices/MyServices.jsx
















const MyServices_MyServices = (props)=>{
    const { isAuth , user , access_token: accessToken  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const router = (0,next_router.useRouter)();
    const { data: componentProp  } = props;
    const staticTexts = useMyServices({
        componentProp
    });
    const selectedSortItem = (0,helper/* getSortItemBasedOnURL */.KE)(staticTexts, {
        name: staticTexts.newToOld,
        query: "new"
    });
    const [servicelist, setServicelist] = (0,react.useState)({
        active: [],
        past: []
    });
    const [menuItems, setMenuItems] = (0,react.useState)([]);
    const [config, setInitialConfig] = (0,react.useState)({});
    const [selectedSort, setSelectedSort] = (0,react.useState)(selectedSortItem);
    const [selectedTag, setSelectedTag] = (0,react.useState)(null);
    const [isLoading, setIsLoading] = (0,react.useState)(true);
    const [loader, setLoader] = (0,react.useState)(true);
    const info = (0,react.useRef)({});
    const dispatch = (0,es/* useDispatch */.I0)();
    const { newToOld , oldToNew , AToZ , ZToA  } = staticTexts;
    const sorts = [
        {
            name: newToOld,
            query: "new"
        },
        {
            name: oldToNew,
            query: "old"
        },
        {
            name: AToZ,
            query: "atoz"
        },
        {
            name: ZToA,
            query: "ztoa"
        }
    ];
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            setInitialState(config);
            const locale = get_default()(config, "internationalization.locale", "");
            info.current = {
                locale: locale
            };
        });
        window.scrollTo({
            top: 1,
            behavior: "smooth"
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(config) && accessToken) {
            setMenuItems((0,orders/* setMenu */.K0)(config, staticTexts));
            getServiceData();
        }
    }, [
        config,
        accessToken
    ]);
    (0,react.useEffect)(()=>{
        if (selectedTag) {
            const tag = selectedTag === "active" ? "active" : "past";
            onSort(selectedSort, tag);
        }
    }, [
        selectedTag
    ]);
    const setInitialState = async (config)=>{
        const accountSettingsPath = await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.accountSettingsPath", ""));
        const myFavoritesPagePath = await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.myFavoritesPagePath", ""));
        const orderHistoryPath = await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.orderHistoryPath", ""));
        const myProductsPath = await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.myProductsPath", ""));
        const myServicesPath = await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.myServicesPath", ""));
        const orderDetailsUrl = get_default()(config, "general.orderDetailsPath", "");
        const continueShopUrl = get_default()(config, "general.continueShopPath", "");
        const currencySign = get_default()(config, "internationalization.currencySign", "");
        setInitialConfig({
            accountSettingsPath,
            myFavoritesPagePath,
            orderHistoryPath,
            myProductsPath,
            myServicesPath,
            orderDetailsUrl,
            continueShopUrl,
            currencySign
        });
    };
    const redirect = (url)=>{
        router.push(url);
    };
    const signOut = ()=>{
        dispatch((0,authSlice/* logout */.kS)());
    };
    const getServiceData = async ()=>{
        if (accessToken) {
            dispatch(getServices()).unwrap().then(async (service)=>{
                var ref;
                var ref1;
                const lineItems = (ref1 = (ref = service[0]) === null || ref === void 0 ? void 0 : ref.lineItems) !== null && ref1 !== void 0 ? ref1 : [];
                const productData = (lineItems === null || lineItems === void 0 ? void 0 : lineItems.length) > 0 && await (0,cartHelper/* getProductsById */.OA)(lineItems === null || lineItems === void 0 ? void 0 : lineItems.map((lineItem)=>lineItem.productId));
                const data = lineItems.reduce((p, c)=>{
                    var ref, ref1;
                    const expirationDate = moment_default()(c.custom.fields.expirationDate);
                    const purchasedDate = moment_default()(c.custom.fields.lastPurchasedOn);
                    const masterVariant = (ref = productData === null || productData === void 0 ? void 0 : productData.find((v)=>v.id === c.productId)) === null || ref === void 0 ? void 0 : ref.masterVariant;
                    const obj = {
                        brandName: get_default()(masterVariant === null || masterVariant === void 0 ? void 0 : masterVariant.attributes.find((attr)=>attr.name === "CustomerFacingBrand"), "value", ""),
                        expirationDate: expirationDate.isValid() ? expirationDate.format("MM/DD/YYYY") : false,
                        lastPurchasedOn: purchasedDate.format("MM/DD/YYYY"),
                        image: (ref1 = masterVariant === null || masterVariant === void 0 ? void 0 : masterVariant.images[0]) === null || ref1 === void 0 ? void 0 : ref1.url,
                        name: c.name["en-US"]
                    };
                    if (expirationDate.isValid() && moment_default()().isAfter(expirationDate)) {
                        p.past.push(obj);
                    } else {
                        p.active.push(obj);
                    }
                    return p;
                }, {
                    past: [],
                    active: []
                });
                const newestToOldestDataActiveServices = data.active.sort(function(a, b) {
                    return new Date(b.lastPurchasedOn) - new Date(a.lastPurchasedOn);
                });
                const tag = data.length ? "past" : "active";
                setServicelist({
                    ...data,
                    active: newestToOldestDataActiveServices
                });
                setSelectedTag(tag);
                setIsLoading(false);
            }).finally(()=>setLoader(false));
        }
    };
    const onSort = (selectedSort, tag)=>{
        const selectedObj = tag === "active" ? servicelist.active : servicelist.past;
        let sortedData = [];
        if (selectedSort.query === "atoz") {
            sortedData = selectedObj.sort((a, b)=>a.name.localeCompare(b.name));
        } else if (selectedSort.query === "new") {
            sortedData = selectedObj.sort((a, b)=>new Date(b.lastPurchasedOn) - new Date(a.lastPurchasedOn));
        } else if (selectedSort.query === "old") {
            sortedData = selectedObj.sort((a, b)=>new Date(a.lastPurchasedOn) - new Date(b.lastPurchasedOn));
        } else {
            sortedData = selectedObj.sort((a, b)=>b.name.localeCompare(a.name));
        }
        setServicelist({
            ...servicelist,
            [tag]: sortedData
        });
        setSelectedSort(selectedSort);
        (0,helper/* replaceSearchUrl */.CjH)("sort", selectedSort.query);
    };
    if (loader) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MyGenericFiller/* default */.Z, {
            data: componentProp,
            title: "myServices"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MyServices_view, {
            i18n: staticTexts,
            servicelist: servicelist,
            showDropdown: true,
            sorts: sorts,
            onSort: onSort,
            continueShoppingData: componentProp,
            isAuth: isAuth,
            user: user,
            logout: signOut,
            data: menuItems,
            redirect: redirect,
            selectedSort: selectedSort,
            isLoading: isLoading
        })
    });
};
/* harmony default export */ var v1_MyServices_MyServices = (MyServices_MyServices);

// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageHeader.jsx + 31 modules
var GlobalPageHeader = __webpack_require__(82660);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageFooter.jsx
var GlobalPageFooter = __webpack_require__(10884);
// EXTERNAL MODULE: ./src/components/Shared/GlobalPage/GlobalPageLayout.jsx
var GlobalPageLayout = __webpack_require__(82706);
// EXTERNAL MODULE: ./components/AemGrid.jsx + 115 modules
var AemGrid = __webpack_require__(17739);
// EXTERNAL MODULE: ./src/hooks/usePageAuth.js
var usePageAuth = __webpack_require__(85614);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./src/components/Shared/UpsellInstallServices/index.jsx + 2 modules
var UpsellInstallServices = __webpack_require__(95843);
;// CONCATENATED MODULE: ./src/pages/my-account/my-services.jsx













const MyServicePage = (param)=>{
    let { locale , tmpData: data , headertmp: header , footertmp: footer , ip , globalScript , footerScript , analysticsScript , analyticsData , datalayerPageName , gbhDataLayerCustom  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,usePageAuth/* default */.Z)();
    (0,react.useEffect)(()=>{
        (0,helper/* getDataLayerObj */.C2G)(analyticsData);
    }, [
        analyticsData
    ]);
    (0,react.useEffect)(()=>{
        dispatch((0,genericSlice/* setDatalayerPageName */.dN)(datalayerPageName));
        dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(gbhDataLayerCustom));
        return ()=>{
            dispatch((0,genericSlice/* setDatalayerPageName */.dN)(""));
            dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(""));
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageLayout/* default */.Z, {
        header: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageHeader/* default */.Z, {
            header: header,
            title: data.title,
            globalScripting: globalScript,
            analysticsScript: analysticsScript
        }),
        footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageFooter/* default */.Z, {
            footer: footer,
            footerScripting: footerScript
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AemGrid/* default */.Z, {
            data: data,
            count: 0,
            myServices: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(v1_MyServices_MyServices, {
                    data: data
                }),
            myGenericFiller: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(MyGenericFiller/* default */.Z, {
                    data: data,
                    title: "myServices"
                }),
            upSellContainer: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(UpsellInstallServices/* default */.Z, {
                    authData: data
                })
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var my_services = (MyServicePage);


/***/ }),

/***/ 95336:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"myserviceWrapper":"MyServices_view_myserviceWrapper__QZoxw"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,6351,6342,4432,7333,4904,361,3574,5921,6773,4607,2634,919,5843,8381,9774,2888,179], function() { return __webpack_exec__(36453); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);